import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface SkeletonProps {
  className?: string;
  shape?: 'rect' | 'text' | 'circle';
}

const shapes: Record<NonNullable<SkeletonProps['shape']>, string> = {
  rect: 'rounded-xl',
  text: 'h-3.5 rounded-full',
  circle: 'rounded-full',
};

/** A placeholder bone in the shape of the content to come; all bones share one shimmer. */
export function Skeleton({ className, shape = 'rect' }: SkeletonProps) {
  return <div aria-hidden className={cn('skeleton', shapes[shape], className)} />;
}

/** Wraps the bones of one block and tells assistive tech what is loading. */
export function SkeletonGroup({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div role="status" aria-busy="true" aria-label={label} className={className}>
      {children}
    </div>
  );
}
